import { useGameLive } from '../lib/liveGame.js';
import { updateApp, usePwa } from '../lib/pwa.js';

/**
 * "Nova versão disponível".
 *
 * ⚠️ **Nunca recarrega sozinho.** A versão nova fica esperando até alguém
 * tocar no botão. Um recarregamento automático no meio de um sorteio faria o
 * operador perder a tela com o salão esperando — e ele não teria como saber
 * por quê.
 *
 * Com partida aberta o aviso muda de tom: em vez de convidar a atualizar
 * agora, ele diz para deixar para o final. O botão continua ali — a decisão
 * é de quem opera, não nossa —, mas o texto deixa claro o custo.
 */
export function UpdateBanner() {
  const pwa = usePwa();
  const gameLive = useGameLive();

  if (!pwa.updateAvailable) return null;

  return (
    <div className="update-banner" role="status" aria-live="polite">
      <div>
        <strong>Nova versão disponível</strong>
        <small>
          {gameLive
            ? 'Atualize ao final da partida — atualizar agora recarrega a tela.'
            : 'Atualizar recarrega a tela.'}
        </small>
      </div>

      <button type="button" className="btn primary" onClick={() => updateApp()}>
        Atualizar
      </button>
    </div>
  );
}
